import { AppEnvironment } from './environment';
/**
 * Configuration du cache React Query
 *
 * Centralise les TTL et Query Keys pour tout le projet
 */

// ============================================================================
// TTL (Time To Live) par type de données
// ============================================================================

export const CACHE_TTL = {
  /** Données rarement modifiées (classes, matières) */
  STATIC: 30 * 60 * 1000,      // 30 minutes

  /** Données semi-statiques (chapitres, leçons) */
  SEMI_STATIC: 10 * 60 * 1000, // 10 minutes

  /** Données dynamiques (exercices) */
  DYNAMIC: 5 * 60 * 1000,      // 5 minutes

  /** Données temps réel (stats, activité) */
  REALTIME: 1 * 60 * 1000,     // 1 minute

  /** Tableaux de bord et statistiques consultés en continu */
  FRESH: 30 * 1000,            // 30 secondes

  /** États vivants (agents, clés, vignettes, plantages) */
  LIVE: 15 * 1000,             // 15 secondes
} as const;

/** Intervalle de relecture des écrans qui suivent un traitement en cours (ms). */
export const POLL_INTERVAL_MS = 10 * 1000;

/** Nombre maximal de lignes demandées au backend, par usage. */
export const FETCH_LIMIT = {
  /** Page de vignettes */
  THUMBNAILS: 30,
  /** Historique d'un dialogue (transactions, consommation) */
  DIALOG: 50,
  /** Listes de travail (ressources, soumissions du tableau de bord, activité) */
  LIST: 100,
  /** Listes d'utilisateurs */
  USERS: 200,
  /** Exports et vues complètes (soumissions en attente, journaux, renouvellement) */
  FULL: 500,
} as const;

// ============================================================================
// Query Keys - Données principales (ApiService)
// ============================================================================

export const dataKeys = {
  all: ['data'] as const,

  // Classes
  classes: (env: AppEnvironment) => [...dataKeys.all, 'classes', env] as const,
  classe: (id: string, env: AppEnvironment) => [...dataKeys.all, 'classe', id, env] as const,

  // Matières
  matieres: (env: AppEnvironment) => [...dataKeys.all, 'matieres', env] as const,
  matiere: (id: string, env: AppEnvironment) => [...dataKeys.all, 'matiere', id, env] as const,

  // Chapitres
  chapitres: (env: AppEnvironment) => [...dataKeys.all, 'chapitres', env] as const,

  // Leçons
  lecons: (env: AppEnvironment) => [...dataKeys.all, 'lecons', env] as const,

  // Exercices
  exercices: (env: AppEnvironment) => [...dataKeys.all, 'exercices', env] as const,
  exercicesByFilters: (env: AppEnvironment, filters: { classeId?: string; matiereId?: string; chapitreId?: string; leconId?: string }) =>
    [...dataKeys.all, 'exercices', 'filtered', env, filters] as const,

  // Admin Users
  adminUsers: (params?: unknown) => [...dataKeys.all, 'adminUsers', params] as const,
};

